import "./excavationPermitButtons.css";
import { downloadExcavationPermitPdf, isExcavationPermit as isExcavationPermitPdf } from "./excavationPermitPdf";
import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
// import "./User.css";
// import "./ColdWorkPermitForm.css";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";
import useClickOutside from "../useClickOutside";
import jsPDF from "jspdf";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import ColdWorkPermitTemplate from "../ColdWorkPermit/ColdWorkPermitTemplate";
import HotWorkPermitTemplate from "../HotWorkPermit/HotWorkPermitTemplate";
import { RxDownload } from "react-icons/rx";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Alert, CircularProgress, Chip } from "@mui/material";
import { Eye, CircleCheck, CircleX, Upload } from "lucide-react";
import { getReviewRowKey, getReviewActionState, resolveDepartmentReview } from "./departmentReviewActions";
import "./excavationDepartmentReviewList.css";
import DepartmentReassignAction from "./DepartmentReassignAction";

function WorkPermitofExcavation({
  isSidebarExpanded,
  designationID,
  status,
  updateNewCounts,
  updateTotalItems,
  updateNotification,
  updateNotificationIds,
}) {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [reviewMetadata, setReviewMetadata] = useState({});
  const [reviewAction, setReviewAction] = useState(null);
  const [actionRemarks, setActionRemarks] = useState("");
  const [actionFile, setActionFile] = useState(null);
  const [submittingAction, setSubmittingAction] = useState(false);
  const [reassignOpen, setReassignOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.reassignmentMessage) {
      setSnackbarMessage(location.state.reassignmentMessage);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true, state: null });
    }
  }, [location, navigate]);
  const showIssuedAtColumn = designations.some(row => ["Issued", "Renewed"].includes(row.request_status));
  const showRejectedAtColumn = designations.some(row => row.request_status === "Rejected");
  const showClosedAtColumn = designations.some(row => row.request_status === "Closed");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const fetchTimeout = useRef(null);
  const [isSearching, setIsSearching] = useState(false);

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  const handleDeletePopup = () => {
    setIsDeletePopup(!isDeletePopup);
  };

  const handleRejectRequest = (permit_id, index) => {
    navigate(`/reject-req/${permit_id}`);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const fetchData = async (currentPage, itemsPerPage, status) => {
    try {
      //   setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(
        `${API_URL}/api/department_review/get_work_permit_requests`,
        // `${API_URL}/api/department/pending_permits`,
        {
          headers: {
            Authorization: authKey,
          },
          params: {
            page: currentPage,
            per_page: itemsPerPage,
            status: status,
          },
        }
      );
      console.log("response.data.permit_details", response.data);
      // Check if permit_details exists and is an array
      if (Array.isArray(response.data.permit_details)) {
        console.log("new pemit details", response.data.permit_details)
        setDesignations(response.data.permit_details);
        setTotalItems(response.data.totalItems);
        updateTotalItems?.(response.data.tabCounts);
        updateNotification?.(response.data.notificationCounts);
        updateNotificationIds?.(response.data.notificationIds);
        updateNewCounts?.(response.data.newCounts);
      } else {
        setDesignations([]);
        setTotalItems(0);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  const handleSearch = async (currentPage, itemsPerPage) => {
    if (!searchInput.trim()) {
      fetchData(currentPage, itemsPerPage);
      return;
    }
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/search_designations`, {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
        params: {
          query: searchInput,
          page: currentPage,
          per_page: itemsPerPage,
        },
      });

      if (response.status === 200) {
        setDesignations(response.data.Designations);
      } else {
        console.error("Error fetching search results:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    //   clearTimeout(fetchTimeout.current);

    //   // Debounce API calls by 600ms
    //   fetchTimeout.current = setTimeout(() => {
    //     if (searchInput.trim() === "") {
    //       // Fetch data when not searching and status is present
    //       if (status) {
    //         fetchData(page, itemsPerPage, status);
    //       }
    //     } else {
    //       // Handle search scenario
    //       setIsSearching(true);
    //       handleSearch(page, itemsPerPage);
    //     }
    //   }, 600);

    //   return () => clearTimeout(fetchTimeout.current);

    if (status) {
      fetchData(page, itemsPerPage, status);
    } else {
      // Handle search scenario
      setIsSearching(true);
      handleSearch(page, itemsPerPage);
    }
  }, [searchInput, page, itemsPerPage, status]);

  useEffect(() => {
    let active = true;
    setReviewMetadata({});
    const rows = designations.filter(row => isExcavationPermitPdf(row.work_permit_name));
    if (!rows.length) return () => { active = false; };
    const headers = { Authorization: localStorage.getItem("authKey") };
    (async () => {
      const pendingResponse = await axios.get(`${API_URL}/api/department/pending_permits`, { headers }).catch(() => null);
      const pending = pendingResponse?.data?.permits || [];
      const permitIds = [...new Set(rows.map(row => row.permit_id))];
      let next = 0;
      // Limit concurrent lookups and share a response across departments of one permit.
      const worker = async () => {
        while (active && next < permitIds.length) {
          const permitId = permitIds[next++];
          try {
            const response = await axios.get(`${API_URL}/api/permit/department/my-observations/${permitId}`, { headers });
            if (!active) return;
            const updates = {};
            rows.filter(row => String(row.permit_id) === String(permitId)).forEach(row => {
              updates[getReviewRowKey(row)] = {
                approval: resolveDepartmentReview(row, response.data?.approvals || [], pending),
              };
            });
            setReviewMetadata(previous => ({ ...previous, ...updates }));
          } catch {
            if (!active) return;
            const updates = {};
            rows.filter(row => String(row.permit_id) === String(permitId)).forEach(row => {
              updates[getReviewRowKey(row)] = { error: true };
            });
            setReviewMetadata(previous => ({ ...previous, ...updates }));
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, permitIds.length) }, worker));
    })();
    return () => { active = false; };
  }, [designations]);

  const openReviewAction = (row, action) => {
    const metadata = reviewMetadata[getReviewRowKey(row)];
    const availability = getReviewActionState(metadata?.approval, { loading: !metadata, error: metadata?.error });
    if (submittingAction || !(action === "Approve" ? availability.canApprove : availability.canReject)) return;
    setActionRemarks("");
    setActionFile(null);
    setReviewAction({ row, action });
  };

  const submitReviewAction = async () => {
    if (!reviewAction || submittingAction) return;
    const { row, action } = reviewAction;
    setSubmittingAction(true);
    try {
      const headers = { Authorization: localStorage.getItem("authKey") };
      // Recheck saved details and permissions before submitting a stale list row.
      const [observations, pending] = await Promise.all([
        axios.get(`${API_URL}/api/permit/department/my-observations/${row.permit_id}`, { headers }),
        axios.get(`${API_URL}/api/department/pending_permits`, { headers }).catch(() => null),
      ]);
      const approval = resolveDepartmentReview(row, observations.data?.approvals || [], pending?.data?.permits || []);
      const availability = getReviewActionState(approval);
      setReviewMetadata(previous => ({ ...previous, [getReviewRowKey(row)]: { approval } }));
      if (!(action === "Approve" ? availability.canApprove : availability.canReject)) {
        showSnackbar(action === "Approve" ? availability.approveReason : availability.rejectReason, "info");
        setReviewAction(null);
        return;
      }
      const payload = new FormData();
      payload.append("permit_id", row.permit_id);
      payload.append("department_id", approval.department_id);
      payload.append("action", action);
      payload.append("remarks", actionRemarks);
      if (actionFile) payload.append("attachments", actionFile);
      const response = await axios.post(`${API_URL}/api/permit/department/approve`, payload, {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
      });
      setReviewAction(null);
      showSnackbar(response.data?.message || `Department review ${action === "Approve" ? "approved" : "rejected"} successfully.`, "success");
      await fetchData(page, itemsPerPage, status);
    } catch (error) {
      showSnackbar(error.response?.data?.message || "Unable to submit this department review. Please try again.", "error");
    } finally {
      setSubmittingAction(false);
    }
  };

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleArchivedDesignation = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/archive_department`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        showSnackbar("Data archived successfully");
        const updatedDesignations = designations.filter(
          (designation) => !selectedRows.includes(designation.ID)
        );
        setDesignations(updatedDesignations);
        setSelectedRows([]);
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to delete departments");
      }
    } catch (error) {
      console.error("An error occurred while deleting designations:", error);
    }
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const handleGenratePermit = (permit_id, work_permit_name, wp_status) => {
    console.log("ID:", permit_id); // Log the ID
    // navigate(`/cold-work-permit-inspection-view/${id}`);
    navigate(`/view-pdf-formate/${permit_id}/${work_permit_name}/${wp_status}`);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage, status);
    }
    setSearchInput("");
  };
  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };

  const handleApproveExtension = (permit_id) => {
    navigate(`/view-extension/${permit_id}`);
  };

  const handleClosingRequest = (permit_id) => {
    // if (request_status === "Issued") {
    navigate(`/close-request-tab-inspection/${permit_id}`);
    // }
  };

  function getRequestStatusColor(request_status) {
    switch (request_status) {
      case "Draft":
        return "gray";
      case "In Review":
        return "blue";
      case "Submitted":
        return "orange";
      case "Approved":
        return "green";
      case "Pending Approval":
        return "purple";
      case "Renewed":
        return "teal";
      case "Closed":
        return "#d42d2d";
      case "Rejected":
        return "red";
      case "Issued":
        return "darkgreen";
      case "Safety Verified":
        return "#fb7c1f";
      case "Fire&Safety Verified": // ✅ Added Fire & Safety status
        return "#FF4500"; // Example: OrangeRed
      default:
        return "black";
    }
  }

  function getStatusColor(status) {
    switch (status) {
      case "Active":
        return "green";
      case "Inactive":
        return "gray";
      case "Closed":
        return "#d42d2d";
      case "Expired":
        return "red";
      default:
        return "black";
    }
  }

  const handleDownloadPdf = async (formId, work_permit_name) => {
    if (isExcavationPermitPdf(work_permit_name)) {
      return downloadExcavationPermitPdf(formId, { isSidebarExpanded });
    }
    let TemplateComponent;

    switch (work_permit_name?.toLowerCase()) {
      case "cold work":
        TemplateComponent = ColdWorkPermitTemplate;
        break;
      case "hot work":
        TemplateComponent = HotWorkPermitTemplate;
        break;
      default:
        console.error("Unknown permit type:", work_permit_name);
        return;
    }

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_permit_details`, {
        headers: { Authorization: authKey },
        params: { permit_id: formId },
      });

      if (response.status === 200) {
        const permitDetails = response.data;

        const tempDiv = document.createElement("div");
        document.body.appendChild(tempDiv);

        ReactDOM.render(
          <TemplateComponent
            permitDetails={permitDetails}
            isSidebarExpanded={isSidebarExpanded}
          />,
          tempDiv
        );

        // Generate PDF from the rendered content
        const section1 = tempDiv.querySelector("#section1");
        const section2 = tempDiv.querySelector("#section2");

        if (!section1 || !section2) {
          console.error("PDF sections not found.");
          return;
        }

        const pdf = new jsPDF("p", "mm", "a4");
        const options = {
          scale: 2,
          useCORS: true,
          backgroundColor: "yellow",
          windowWidth: 1550,
        };

        // Render Section 1
        const canvas1 = await html2canvas(section1, options);
        const imgData1 = canvas1.toDataURL("image/jpeg", 0.8);
        const imgWidth1 = 190; // A4 width minus padding
        const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

        pdf.addImage(imgData1, "JPEG", 10, 5, imgWidth1, imgHeight1);

        // Add Section 2
        pdf.addPage();
        const canvas2 = await html2canvas(section2, options);
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.8);
        const imgWidth2 = 190;
        const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

        pdf.addImage(imgData2, "JPEG", 10, 5, imgWidth2, imgHeight2);
        const fileSafePermitName = work_permit_name.replace(/\s+/g, "_"); // or toUpperCase(), etc.
        const fileName = `${fileSafePermitName}_Permit_${formId}.pdf`;
        pdf.save(fileName);
        // pdf.save(`Cold_Work_Permit_${formId}.pdf`);

        // Clean up the temporary div
        ReactDOM.unmountComponentAtNode(tempDiv);
        document.body.removeChild(tempDiv);
      } else {
        console.error("Failed to fetch permit details:", response.statusText);
      }
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  const handleViewPermit = (
    permitId, department_name
  ) => {
    navigate(
      `/excavation-permit-view/${permitId}/${encodeURIComponent(department_name || "")}`
    );
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded excavation-review-list" : "collapsed excavation-review-list"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>All Work Permit</PageBackTitle>

              <div className="data-list-heading-content-right-side">
                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
                <button
                  className="sort-button"
                  onClick={handleSortpopup}
                  ref={buttonRef}
                >
                  <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                </button>
              </div>
            </div>
          </div>

          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : designations.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th className="center-alignment">REQUEST ID</th>
                        <th>PERMIT TYPE</th>
                        <th>RECEIVER NAME</th>
                        <th>WORK DESCRIPTION</th>
                        <th>REQUEST STATUS</th>
                        <th>STATUS</th>
                        <th>APPROVAL STATUS</th>
                        <th>REQUESTED AT</th>
                        {showIssuedAtColumn && <th>ISSUED AT</th>}
                        {showRejectedAtColumn && <th>REJECTED AT</th>}
                        {showClosedAtColumn && <th>CLOSED AT</th>}
                        {/* {designations.some(
                          (designation) =>
                            designation.request_status === "Issued" ||
                            designation.request_status === "Renewed"
                        ) && <th>ISSUED AT</th>}

                        {designations.some(
                          (designation) =>
                            designation.request_status === "Reject"
                        ) && <th>REJECTED AT</th>}

                        {designations.some(
                          (designation) =>
                            designation.request_status === "Closed"
                        ) && <th>CLOSED AT</th>} */}

                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {designations.map((designation, index) => {
                        const metadata = reviewMetadata[getReviewRowKey(designation)];
                        const actions = getReviewActionState(metadata?.approval, { loading: !metadata, error: metadata?.error });
                        return (
                        <tr key={`${getReviewRowKey(designation)}:${index}`} className="hoverable-row">
                          <td className="center-alignment">{index + 1}</td>
                          <td
                            className="center-alignment"
                            style={{ color: "red" }}
                          >
                            {designation.request_id || "NA"}
                          </td>
                          <td>{designation.work_permit_name || "NA"}</td>
                          <td>{designation.receiver_name || "NA"}</td>
                          <td>{designation.work_description || "NA"}</td>

                          <td
                            style={{
                              color: getRequestStatusColor(
                                designation.request_status
                              ),
                              fontWeight: "bold",
                            }}
                          >
                            {designation.request_status || "NA"}
                          </td>

                          <td
                            style={{
                              color: getStatusColor(designation.status),
                              fontWeight: "bold",
                            }}
                          >
                            {designation.status || "NA"}
                          </td>

                          <td>{designation.approval_status || "NA"}</td>

                          <td>
                            {designation.created_at
                              ? new Date(designation.created_at)
                                  .toUTCString()
                                  .split("GMT")[0]
                                  .trim() + " IST"
                              : "NA"}
                          </td>

                          {showIssuedAtColumn && (
                            <td>
                              {designation.issued_date
                                ? new Date(designation.issued_date)
                                    .toUTCString()
                                    .split("GMT")[0]
                                    .trim() + " IST"
                                : "NA"}
                            </td>
                          )}

                          {showRejectedAtColumn && (
                            <td>
                              {designation.closed_at
                                ? new Date(designation.closed_at)
                                    .toUTCString()
                                    .split("GMT")[0]
                                    .trim() + " IST"
                                : "NA"}
                            </td>
                          )}

                          {showClosedAtColumn && (
                            <td>
                              {designation.closed_at
                                ? new Date(designation.closed_at)
                                    .toUTCString()
                                    .split("GMT")[0]
                                    .trim() + " IST"
                                : "NA"}
                            </td>
                          )}

                          <td className="permit-buttons1">
                            <div className="excavation-list-actions">
                            <button
                              className="excavation-list-action excavation-list-view excavation-permit-button excavation-permit-button--view"
                              onClick={() =>
                                handleViewPermit(
                                  designation?.permit_id,
                                  designation?.review_department_name || designation?.review_department || designation?.department,
                                  designation?.permit_type_id,
                                  designation?.work_permit_name,
                                  "wp_fands"
                                )
                              }
                            >
                              <Eye size={15} aria-hidden="true" /> View
                            </button>
                            {isExcavationPermitPdf(designation.work_permit_name) && actions.visible && (
                              <>
                                <Tooltip title={actions.rejectReason} arrow>
                                  <span>
                                    <button
                                      type="button"
                                      className="excavation-list-action excavation-list-reject excavation-permit-button excavation-permit-button--reject"
                                      disabled={!actions.canReject || submittingAction || reassignOpen}
                                      onClick={() => openReviewAction(designation, "Reject")}
                                      aria-label={`Reject ${designation.request_id || designation.permit_id} ${designation.review_department_name || "department"} review`}
                                    >
                                      <CircleX size={15} aria-hidden="true" /> Reject
                                    </button>
                                  </span>
                                </Tooltip>
                                <Tooltip title={actions.approveReason} arrow>
                                  <span>
                                    <button
                                      type="button"
                                      className="excavation-list-action excavation-list-approve excavation-permit-button excavation-permit-button--approve"
                                      disabled={!actions.canApprove || submittingAction || reassignOpen}
                                      onClick={() => openReviewAction(designation, "Approve")}
                                      aria-label={`Approve ${designation.request_id || designation.permit_id} ${designation.review_department_name || "department"} review`}
                                    >
                                      {!metadata ? <CircularProgress size={13} color="inherit" /> : <CircleCheck size={15} aria-hidden="true" />} Approve
                                    </button>
                                  </span>
                                </Tooltip>
                              </>
                            )}
                            {isExcavationPermitPdf(designation.work_permit_name) && (
                              <DepartmentReassignAction
                                permitId={designation.permit_id}
                                permitLabel={designation.request_id}
                                departmentId={designation.review_department_id}
                                departmentName={designation.review_department_name || designation.review_department || designation.department}
                                approvalStatus={designation.approval_status}
                                disabled={submittingAction || reassignOpen || Boolean(reviewAction)}
                                onBusyChange={setReassignOpen}
                                onSuccess={async message => {
                                  setReviewMetadata({});
                                  showSnackbar(message, "success");
                                  await fetchData(page, itemsPerPage, status);
                                }}
                              />
                            )}
                            </div>

                            {/* {designation?.request_status === "Rejected" && (
                              <button
                                className="new-button-download"
                                onClick={() =>
                                  handleRejectRequest(designation.permit_id)
                                }
                              >
                                View
                              </button>
                            )} */}

                            {/* {(designation.request_status === "Renewed" ||
                              designation.request_status === "Issued") && (
                              <button
                                className="new-button-download"
                                onClick={() =>
                                  handleDownloadPdf(
                                    designation.permit_id,
                                    designation.work_permit_name
                                  )
                                }
                              >
                                <RxDownload className="dnld-btn" />
                              </button>
                            )} */}

                            {/* {designation.has_extension_request === true && (
                              <div className="new-permit dot-relative">
                                <button
                                  className="new-button-download view-pulse-button"
                                  onClick={() =>
                                    handleApproveExtension(
                                      designation.permit_id,
                                      designation.request_status
                                    )
                                  }
                                >
                                  View Extension Request
                                </button>
                                <div className="red-button"></div>
                              </div>
                            )} */}

                            {/* {designation.has_closure_request === true && (
                              <div className="new-permit dot-relative">
                                <button
                                  className="new-button-download view-pulse-button"
                                  onClick={() =>
                                    handleClosingRequest(
                                      designation.permit_id,
                                      designation.request_status
                                    )
                                  }
                                >
                                  View Close Request
                                </button>
                                <div className="red-button-close"></div>
                              </div>
                            )} */}
                          </td>
                        </tr>
                      );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Data Found</div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={Boolean(reviewAction)}
        onClose={() => !submittingAction && setReviewAction(null)}
        fullWidth maxWidth="sm"
        PaperProps={{ className: "excavation-review-list-dialog" }}
        aria-labelledby="excavation-list-action-title"
      >
        <DialogTitle id="excavation-list-action-title" className={reviewAction?.action === "Reject" ? "is-reject" : "is-approve"}>
          {reviewAction?.action === "Reject" ? <CircleX size={23} /> : <CircleCheck size={23} />}
          {reviewAction?.action} department review
        </DialogTitle>
        <DialogContent>
          <Typography className="excavation-list-dialog-context">
            {reviewAction?.row.request_id || reviewAction?.row.permit_id} · {reviewAction?.row.review_department_name || reviewAction?.row.review_department}
          </Typography>
          <Alert severity={reviewAction?.action === "Reject" ? "warning" : "info"} sx={{ mb: 2 }}>
            {reviewAction?.action === "Reject"
              ? "This will reject the department review. You can add remarks and supporting documents below."
              : "This will approve the saved department review and move the permit forward."}
          </Alert>
          <label className="excavation-list-field-label" htmlFor="excavation-list-remarks">Remarks <span>(optional)</span></label>
          <TextField
            id="excavation-list-remarks" value={actionRemarks}
            onChange={event => setActionRemarks(event.target.value)}
            disabled={submittingAction} multiline minRows={3} fullWidth
            placeholder="Add any observations or context for this decision…"
          />
          <div className="excavation-list-attachment">
            <Button className="excavation-list-attach-button" component="label" variant="outlined" startIcon={<Upload size={16} />} disabled={submittingAction}>
              Attach file
              <input type="file" hidden onChange={event => setActionFile(event.target.files?.[0] || null)} />
            </Button>
            {actionFile ? <Chip label={actionFile.name} onDelete={submittingAction ? undefined : () => setActionFile(null)} />
              : <Typography variant="caption" color="text.secondary">Optional supporting document</Typography>}
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="excavation-list-cancel-button excavation-permit-button" variant="outlined" onClick={() => setReviewAction(null)} disabled={submittingAction}>Cancel</Button>
          <Button
            className={`excavation-list-confirm-button excavation-permit-button ${reviewAction?.action === "Reject" ? "excavation-permit-button--reject" : "excavation-permit-button--approve"}`}
            variant="contained" color={reviewAction?.action === "Reject" ? "error" : "success"}
            onClick={submitReviewAction} disabled={submittingAction}
            startIcon={submittingAction ? <CircularProgress size={16} color="inherit" /> : reviewAction?.action === "Reject" ? <CircleX size={16} /> : <CircleCheck size={16} />}
          >
            {submittingAction ? "Submitting…" : `Confirm ${reviewAction?.action || ""}`}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default WorkPermitofExcavation;
